module.exports = __webpack_public_path__ + "static/policy_orange.3beacd70.svg";